<template>
  <section>
    <b-button
      :rounded="rounded"
      :label="label"
      :type="type"
      :size="size"
      :icon-left="iconLeft"
      :close="closeModal"
      @click="isCardModalActive = true"
    />
    <b-modal v-model="isCardModalActive" :width="'auto'" scroll="keep">
        <div class="card boxWithBorder" style="width: 80%; margin: auto;">
        <slot name="modalContent"></slot>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: "ShowModalButton",
  data() {
    return {
      isCardModalActive: false,
    }
  },
  props: {
    label: String,
    type: String,
    size: {
      type: String,
      default: 'is-small',
    },
    iconLeft: String,
    rounded: {
      type: Boolean,
      default: false,
    },
    closeModal:{
      type: Boolean,
      default: false,
    }
  },
  watch:{
    closeModal(newVal, prevVal){
      // console.log('watching close modal');
      // console.log('prevVal:', JSON.stringify(prevVal));
      // console.log('newVal:', JSON.stringify(newVal));
      if(newVal === true){
        this.isCardModalActive = false;
      }
    }
  },
}
</script>

<style scoped>
</style>